import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Rotate extends BaseOption {
  static userInterfaceComponent = {
    label: "Rotate",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: -180,
      max: 180,
      append: "deg",
      defaultEmptyValue: 0,
    },
  };

  static defaultValue = 0;

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue == 0) {
      return 0;
    }
    return `${configValue}deg`;
  }
}
